// Bootstrap JavaScript Bundle
import $ from 'jquery';
import Cookies from 'js-cookie';

import './jquery.typeahead.css';
import './typeahead.custom.css';

import 'jquery-typeahead';
import './typeahead.custom.js';

// Import Modernizr for WebP detection
import './modernizr-webp';

// Import Bootstrap JS and expose it globally
import * as bootstrap from './bootstrap/bootstrap.bundle.min.js';

// Make jQuery, Cookies, and Bootstrap available globally (for existing code compatibility)
window.$ = window.jQuery = $;
window.Cookies = Cookies;
window.bootstrap = bootstrap;

// WebP detection and smart image loading
Modernizr.on('webp', (result) => {
  var attrib = result ? 'webp' : 'fallback';
  $.each($('.smartImage'), function (index, img) {
    $(img).attr('src', $(img).data(attrib));
  });
  $.each($('.smartImageBackground'), function (index, div) {
    $(div).css('background-image', 'url(' + $(div).data(attrib) + ')');
  });
});

// Extend FAB object with additional methods that require jQuery
if (window.FAB) {
  /**
   * Equalize card heights for desktop and mobile carousels
   * @param {Object} config - Configuration object
   * @param {string} config.carouselId - ID of the carousel element (e.g., '#testimonialsCarousel')
   * @param {string} config.cardSelector - Selector for cards (e.g., '.testimonials-card')
   * @param {string} [config.textSelector] - Optional single selector for text elements to equalize (e.g., '.testimonial-text')
   * @param {string[]} [config.textSelectors] - Optional array of selectors for multiple text elements to equalize separately (e.g., ['.tips-card-title', '.tips-card-summary'])
   * @param {string} [config.desktopContainer] - Selector for desktop container (default: '.d-md-block')
   * @param {string} [config.mobileContainer] - Selector for mobile container (default: '.d-md-none')
   * @param {number} [config.breakpoint] - Breakpoint in pixels (default: 768)
   */
  window.FAB.equalizeCardHeights = function (config) {
    var defaults = {
      desktopContainer: '.d-md-block',
      mobileContainer: '.d-md-none',
      breakpoint: 768,
    };
    var options = Object.assign({}, defaults, config);

    if (!options.carouselId || !options.cardSelector) {
      console.warn(
        'FAB.equalizeCardHeights: carouselId and cardSelector are required'
      );
      return;
    }

    // Support both textSelector (single) and textSelectors (array) for backward compatibility
    var textSelectors = [];
    if (options.textSelectors && Array.isArray(options.textSelectors)) {
      textSelectors = options.textSelectors;
    } else if (options.textSelector) {
      textSelectors = [options.textSelector];
    }

    var $desktopCards = $(
      options.desktopContainer + ' ' + options.cardSelector
    );
    var $mobileCards = $(options.mobileContainer + ' ' + options.cardSelector);

    // Helper function to equalize multiple text selectors
    var equalizeTextSelectors = function (
      $cards,
      containerSelector,
      cardSelector
    ) {
      textSelectors.forEach(function (textSelector) {
        var $textElements = $(
          containerSelector + ' ' + cardSelector + ' ' + textSelector
        );
        if ($textElements.length > 0) {
          // Reset heights first
          $textElements.css('height', 'auto');

          // Find the maximum height
          var maxHeight = 0;
          $textElements.each(function () {
            var height = $(this).outerHeight();
            if (height > maxHeight) {
              maxHeight = height;
            }
          });

          // Set all elements to the maximum height
          $textElements.css('height', maxHeight + 'px');
        }
      });
    };

    // Helper function to reset text selectors
    var resetTextSelectors = function (containerSelector, cardSelector) {
      textSelectors.forEach(function (textSelector) {
        var $textElements = $(
          containerSelector + ' ' + cardSelector + ' ' + textSelector
        );
        $textElements.css('height', 'auto');
      });
    };

    // Equalize desktop cards when on desktop
    if ($desktopCards.length > 0 && window.innerWidth >= options.breakpoint) {
      // Reset heights first
      $desktopCards.css('height', 'auto');
      resetTextSelectors(options.desktopContainer, options.cardSelector);

      // Equalize text selectors
      equalizeTextSelectors(
        $desktopCards,
        options.desktopContainer,
        options.cardSelector
      );

      // Find the maximum card height
      var maxCardHeight = 0;
      $desktopCards.each(function () {
        var height = $(this).outerHeight();
        if (height > maxCardHeight) {
          maxCardHeight = height;
        }
      });

      // Set all desktop cards to the maximum height
      $desktopCards.css('height', maxCardHeight + 'px');
    } else {
      // Reset desktop heights on mobile
      $desktopCards.css('height', 'auto');
      resetTextSelectors(options.desktopContainer, options.cardSelector);
    }

    // Equalize mobile cards when on mobile
    if ($mobileCards.length > 0 && window.innerWidth < options.breakpoint) {
      // Temporarily make all carousel items measurable
      var $carouselItems = $(options.carouselId + ' .carousel-item');

      // Store original inline styles
      var originalStyles = [];
      $carouselItems.each(function (index) {
        originalStyles[index] = $(this).attr('style') || '';
      });

      // Temporarily show all items for measurement
      $carouselItems.css({
        position: 'absolute',
        visibility: 'hidden',
        width: '100%',
        display: 'block',
        opacity: '0',
      });

      // Reset heights first
      $mobileCards.css('height', 'auto');
      resetTextSelectors(options.mobileContainer, options.cardSelector);

      // Equalize text selectors
      equalizeTextSelectors(
        $mobileCards,
        options.mobileContainer,
        options.cardSelector
      );

      // Find the maximum card height
      var maxMobileCardHeight = 0;
      $mobileCards.each(function () {
        var height = $(this).outerHeight();
        if (height > maxMobileCardHeight) {
          maxMobileCardHeight = height;
        }
      });

      // Set all mobile cards to the maximum height
      $mobileCards.css('height', maxMobileCardHeight + 'px');

      // Remove all inline styles from carousel items to let Bootstrap handle them
      $carouselItems.removeAttr('style');
    } else {
      // Reset mobile heights on desktop
      $mobileCards.css('height', 'auto');
      resetTextSelectors(options.mobileContainer, options.cardSelector);
    }
  };
}

// Export for potential use in other modules
export { $ as jQuery, $ as default, Cookies, bootstrap };
